import { useNavigate } from 'react-router-dom';
import "./CallScoreHome.scss";
import {ReactComponent as UserIcon} from "../../assets/icons/User.svg";
import {ReactComponent as RightArrowIcon} from "../../assets/icons/ArrowRight.svg";
import {ReactComponent as RobotIcon} from "../../assets/icons/Robot.svg";
import {ROUTES} from "../../constants";

const CallScore = () => {
  const navigate = useNavigate();

  const handleFirstTileClick = () => {
    navigate(ROUTES.HUMAN_CALL_SCORE);
  };

  const handleScoreAIAgentClick = () => {
    navigate(ROUTES.SCORE_AI_AGENT);
  };

  return (
    <div className="call-score-home-container">
        <p className={"title"}>Call Score</p>
        <p className={"description"}>Score a human or AI agent call based on your chosen criteria.</p>
        <button className="call-score-button" onClick={handleFirstTileClick}>
            <div className={"button-name"}>
                <UserIcon/>
                <p>Score a Human Call</p>
            </div>
            <div className={"right-arrow"}>
                <RightArrowIcon/>
            </div>
      </button>
      <button className="call-score-button" onClick={handleScoreAIAgentClick}>
          <div className={"button-name"}>
              <RobotIcon/>
              <p>Score an AI Agent Call</p>
          </div>
          <div className={"right-arrow"}>
              <RightArrowIcon />
          </div>
      </button>
    </div>
  );
};

export default CallScore;
